var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, TextField } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { useGetClientsListQuery } from '../../../../application/features/clients/client-api';
import { useLazyGetMachineQuery, useUpdateMachineMutation } from '../../../../application/features/machines/machine-api';
import useTranslate from '../../../../localization/helpers';
var EditMachine = function (_a) {
    var open = _a.open, machineId = _a.machineId, onClose = _a.onClose;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var _c = __read(useLazyGetMachineQuery(), 2), getMachine = _c[0], machine = _c[1].data;
    var _d = useGetClientsListQuery(), _e = _d.data, clientsList = _e === void 0 ? [] : _e, clientsFetching = _d.isFetching;
    var _f = __read(useUpdateMachineMutation(), 2), triggerUpdateMachine = _f[0], _g = _f[1], isLoading = _g.isLoading, isSuccess = _g.isSuccess;
    var _h = useForm({
        defaultValues: {
            name: '',
            type: '',
            brand: '',
            clients: []
        }
    }), control = _h.control, handleSubmit = _h.handleSubmit, reset = _h.reset, errors = _h.formState.errors;
    useEffect(function () {
        machineId && getMachine(machineId);
    }, [machineId, getMachine]);
    useEffect(function () {
        if (isSuccess) {
            reset();
            onClose();
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.asset'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    useEffect(function () {
        if (machine) {
            reset({
                id: machine.id,
                name: machine.name,
                type: machine.type,
                brand: machine.brand,
                clients: machine.clients
            });
        }
    }, [machine, reset]);
    var closeDialog = function () {
        reset();
        onClose();
    };
    var onSubmit = function (machineDto) {
        triggerUpdateMachine(machineDto);
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [tWithFunction('actions.updateFunction', 'common.asset'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsx(DialogContent, { dividers: true, sx: {
                    pb: 4,
                    px: 4
                }, children: _jsx(Box, { component: 'form', noValidate: true, autoComplete: 'off', mt: 1, children: _jsxs(Grid, { container: true, spacing: 1.5, children: [_jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'name', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'common.name')
                                        },
                                        maxLength: {
                                            value: 256,
                                            message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { label: translate('common.name'), type: 'text', fullWidth: true, value: value, onChange: onChange, disabled: isLoading, error: !!errors.name, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'type', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'assets.type')
                                        },
                                        maxLength: {
                                            value: 256,
                                            message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { label: translate('assets.type'), type: 'text', fullWidth: true, value: value, onChange: onChange, disabled: isLoading, error: !!errors.type, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.type) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'brand', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: tWithField('validations.fieldIsRequired', 'assets.brand')
                                        },
                                        maxLength: {
                                            value: 128,
                                            message: translate('validations.maximumCharactersAllowed', { count: 128 })
                                        }
                                    }, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsxs(FormControl, { variant: 'outlined', size: 'medium', fullWidth: true, children: [_jsx(TextField, { label: translate('assets.brand'), type: 'text', fullWidth: true, value: value, onChange: onChange, disabled: isLoading, error: !!errors.brand, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.brand) === null || _b === void 0 ? void 0 : _b.message })] }));
                                    } }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'clients', control: control, render: function (_a) {
                                        var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                        return (_jsx(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: _jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, loading: clientsFetching, disabled: isLoading, options: clientsList, value: clientsList.filter(function (option) { return value.includes(option.id); }), isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, getOptionDisabled: function (option) { return !option.isActive; }, disableCloseOnSelect: true, limitTags: 4, slotProps: { chip: { size: 'small', variant: 'soft' } }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.clients'), error: !!errors.clients }))); }, onChange: function (_, value) {
                                                    onChange(value ? value.map(function (val) { return val.id; }) : []);
                                                }, renderOption: function (props, option, _a) {
                                                    var selected = _a.selected;
                                                    return (_createElement("li", __assign({}, props, { key: option.id }),
                                                        _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                                        option.name));
                                                }, sx: {
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '8px',
                                                        '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                            padding: '3.5px 4px 3.5px 8px'
                                                        }
                                                    }
                                                } }) }));
                                    } }) })] }) }) }), _jsxs(DialogActions, { children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', onClick: closeDialog, children: translate('actions.cancel') }), _jsx(Button, { size: 'medium', variant: 'contained', color: 'warning', onClick: handleSubmit(onSubmit), disabled: isLoading, children: translate('actions.saveChanges') })] })] }));
};
export default EditMachine;
